import React from 'react'
import { SpinnerHolderStyled, SpinnerStyled, DesktopSpinnerOverlayStyled } from './Spinner.styles'

/** @deprecated */
export const DesktopSpinner = () => {
  return (
    <DesktopSpinnerOverlayStyled>
      <SpinnerHolderStyled>
        <SpinnerStyled title='Loading...' />
      </SpinnerHolderStyled>
    </DesktopSpinnerOverlayStyled>
  )
}
